import 'whatwg-fetch';
import { browserHistory } from 'react-router';

export const getUserQuery = (dispatch) => {
  fetch('/api/whoami1.json', {
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(json => {
      if (json.success) {
        dispatch({
          type: 'PARSE_GET_USER',
          data: {
            userView: json.userView,
            participantView: json.participantView,
            sectionsUser: json.participantView.eventBranchIds,
            sections: json.eventBranchViews,
            registrationClosed: json.registrationClosed
          },
        })
      } else {
        dispatch({
          type: 'UNAUTHORIZED_USER',
          registrationClosed: json.registrationClosed
        });
      }
    }).catch(err => {
      dispatch({
        type: 'GET_USER_ERROR',
        error: err,
    })
  })
};

export const getUser = () => (
  (dispatch) => {
     getUserQuery(dispatch);
  }
);

export const downloadSectionsList = () => (
  (dispatch) => {
    fetch('/api/get-sections-conference-list1.json')
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'SECTIONS_LIST',
            sectionsList: json.eventBranchViews
          });
        }
      })
  }
);

export const saveUserChanges = (form) => (
  (dispatch) => {
    dispatch({type: 'RESET_VALIDATION'});
    fetch('/api/user-full-profile-submit.json', {
      method: 'post',
      body: form,
      credentials: 'same-origin'
    })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          getUser();
          dispatch({type: 'SUCCESS_USER_CHANGING', message: json.successMessage});
          dispatch({type: 'RESET_VALIDATION'});
          window.scrollTo(0, 0);
          setTimeout(() => { dispatch({type: 'CLEAR_PARTICIPANT_MESSAGES'}) }, 10000);
        } else {
          dispatch({
            type: 'ERRORS_FROM_SERVER',
            errors: json.errors
          });
        }
      })
  }
);

export const saveSectionChanges = (sections) => (
  (dispatch) => {
    let form = new FormData();
    form.append('eventBranchIds', sections);
    fetch('/api/user-participate.json', {
      method: 'post',
      body: form,
      credentials: 'same-origin'
    })
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (json.success) {
          let message;
          if (sections.length === 0) {
            message = 'Вы отменили свое участие!';
          } else {
            message = 'Изменения сохранены.'
          }
          dispatch({
            type: 'SUCCESS_CHANGING',
            message: message,
            userSections: sections
          });
        } else {
          dispatch({
            type: 'FAILED_CHANGING',
            message: 'Изменения не сохранены.'
          })
        }
      })
      .catch(err => {
        console.log(err);
          dispatch({
            type: 'FAILED_CHANGING',
            message: 'Изменения не сохранены.'
          })
      })
});

export const clearSectionMessages = () => (
  (dispatch) => {
    dispatch({type: 'CLEAR_SECTION_MESSAGES'});
  }
);

export const logoutUser = () => (
  (dispatch) => {
    fetch('/api/j_spring_security_logout', {
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.ok) {
          dispatch({type: 'USER_LOGOUT'});
        }
      })
      .catch(err => {
        console.log(err);
        //TODO:: remove 3 lines after error fixing:
        //Mixed Content: The page at 'https://happydev-lite.ru/auth' was loaded over HTTPS, but requested an insecure resource 'http://happydev-lite.ru/'. This request has been blocked; the content must be served over HTTPS.
        //Fetch API cannot load https://happydev-lite.ru/api/j_spring_security_logout. Redirect failed.
        //TypeError: Failed to fetch
        dispatch({type: 'USER_LOGOUT'});
        getUserQuery(dispatch);
        browserHistory.push('/');
      })
  }
);

export const clearAllMessages = () => (
  (dispatch) => {
    dispatch({type: 'CLEAR_PARTICIPANT_MESSAGES'})
  }
);

export const test = () => (
  (dispatch) => {
    dispatch({type: 'SUCCESS_CHANGING', message: 'hello hello', userSections: []})
  }
);



// WEBPACK FOOTER //
// ./src/actions/participant-action.js